import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { FormMode, CarrierRateFile, CarrierRateSheet, CarrierRate, FileParseStatus } from 'src/app/_models/models';
import { AlertService, AlertOptions, AlertTypes, AlertMessage, AlertSeverity  } from 'src/app/alert/alert.component';
// import { forEach } from '@angular/router/src/utils/collection';
// import { CodegenComponentFactoryResolver } from '@angular/core/src/linker/component_factory_resolver';
import { CarrierRateFilesService } from 'src/app/services/api/carrier-rate-files.service';
import { CarriersService } from 'src/app/services/api/carriers.service';
import { FormBuilder, FormControl, FormGroup, NgForm, FormArray } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-administration-rate-file-component',
  templateUrl: './rate-file.component.html',
  styleUrls: ['./rate-file.component.scss']
})

// https://stackoverflow.com/questions/55617772/angular-7-multiple-outlets-error-cannot-activate-an-already-activated-outle
export class RateFileComponent implements OnInit {
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  @ViewChild('showcarrierratesPopup') showcarrierratesPopup: TemplateRef<any>;
  rateFiles: CarrierRateFile[];
  public tabledata : any[] = [];

  mode: FormMode = FormMode.None;
  formModes = FormMode;
  model: CarrierRateFile = new CarrierRateFile();
  showdiag: boolean = false;
  diagmsg: string;
  selectedRateFile: CarrierRateFile;
  selectedCarrierCode: string;

  public ShowCarrierRates: boolean = false;
  showratefiletabledata: any = [];
  public FileLabel: string;

  rateFileName: string;
  _carrierRateFilesDiag: boolean;


  carriers: SelectItem[] = [
    { label: "FedEx", value: "FX" },
    { label: "GLS", value: "GLS" },
    { label: "UPS", value: "UPS" },
    { label: "Better Trucks", value: "BetterTrucks" },
    //{ label: "TLS Parcel", value: "TLS" },
    { label: "Lone Star Overnight", value: "LSO" },
    { label: "EasyPost", value: "EP" },
    { label: "GORI", value: "GORI" }
  ];

  public ShowMapping: boolean = false;
  CarrierInvoiceFileControllerUrl: string;

  // CarrierRateArray: string[] = ['Weight/Zone', '2','3','4','5','6','7','8'];
  CarrierRateColArray: string[];
  CarrierRateCellArray: string[][];
  CarrierRateArray: any = [];

  constructor(private carrierService: CarriersService
    , private rateFileService: CarrierRateFilesService, private alert: AlertService,
    public dialog: MatDialog, private _snackBar: MatSnackBar, private router: Router, private comm: CommonService, private snackservice: SnackBarService) {
    this.CarrierInvoiceFileControllerUrl = comm.getApiAddress() + '/CarrierRateFiles';
    
  }
  displayedColumns: string[] = ['Carrier', 'Label', 'UploadedOn','Actions'];
  RateFiledataSource = new MatTableDataSource<any>();
  RateFilePopupdataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator,{ static: false }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public FileParseStatus = FileParseStatus;

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.loadListData();
    this.RateFiledataSource.paginator = this.paginator;
    this.RateFilePopupdataSource.paginator = this.paginator;
  }
  openDialog() {    
    let dialogRef = this.dialog.open(this.callAPIDialog);
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result !== 'no') {
          const enabled = "Y"
          console.log(result);
        } else if (result === 'no') {
          console.log('User clicked no.');
        }
      }
    });
}
  onSend(form: NgForm){
  if(form.status === 'INVALID')
  {
    // display error in your form
  }else{
      console.log(form.value)
      this.dialog.closeAll(); // Close opened diaglo
    // do whatever you want to do with your data
}

}
  async loadListData() {
    this._carrierRateFilesDiag = false;
    this.rateFiles = null;
    this.rateFileService.getRateFiles("").subscribe(
      r => {
        this.rateFiles = new Array<CarrierRateFile>();
        for(let rateFile of r){
          this.rateFiles.push(rateFile);
        }
        this.tabledata = this.rateFiles;
        this.RateFiledataSource = new MatTableDataSource(this.rateFiles);
        this.RateFiledataSource.paginator = this.paginator;

      },
      e => {
        this.openSnackBar('Failed to load carrier list', 'error');
      });
  }
  onChangedPageSize($event){
    console.log($event);
  }
  toggleCarrierRateFilesDiag() {
    if (this._carrierRateFilesDiag) 
      this._carrierRateFilesDiag = false;
    else 
      this._carrierRateFilesDiag = true;   
  }
  private _filter(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.rateFiles.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  onSubmit(form: any) {
    switch (this.mode) {
      case FormMode.Find: {
        this.rateFileService.getRateFiles(this.rateFileName).subscribe(
          r => {
            this.rateFiles = new Array<CarrierRateFile>();
            for(let rateFile of r){
              this.rateFiles.push(rateFile);
            }
            this.tabledata = this.rateFiles;
            this.RateFiledataSource = new MatTableDataSource(this.rateFiles);
            this.RateFiledataSource.paginator = this.paginator;
            this.RateFilePopupdataSource.paginator = this.paginator;
          },
          e => {
            this.openSnackBar('Failed to carrier list', 'error');
          });
        break;
      }
      //case FormMode.New: {
      //  if (form.invalid) {
      //  } else {
      //    this.post(form);
      //  }
      //  break;
      //}
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      
      case FormMode.Del: {
        this.delete(form);
        break;
      }
      default: {
        break;
      }
    }
  }

  put(form: any) {
    this.rateFileService.update(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      this.openSnackBar('Updated sucessfully', 'success');
    }, error => {
      this.openSnackBar('Failed to update', 'error');

    });
  }

  delete(p: any) {
    this.dialog
    .open(MessagePopupComponent, {
      data: {
        title: 'Delete Carrier Rate File',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        message: 'Are you sure you want to DELETE the selected rate file?',
      },
    })
    .afterClosed()
    .subscribe((res) => {
      if (res) {
        this.rateFileService.delete(p.id).subscribe(result => {
          this.resetForm();
          this.loadListData();
          this.openSnackBar('Deleted sucessfully', 'success');
        }, error => {
          this.openSnackBar('Failed to delete', 'error');
        });
        }
    });

  }

  resetForm() {
    this.loadListData();
    this.mode = FormMode.None;
    this.model.selected = false;
    this.model = new CarrierRateFile();
  }

  showFind() {
    this.mode = FormMode.Find;
    this.model.selected = false;
    this.model = new CarrierRateFile();
  }

  showNew() {
    //debugger;
    this.mode = FormMode.New;
    this.model.selected = false;
    this.model = new CarrierRateFile();

    this.resetFileManagerForm();
  }

  showEdit(p: any) {
    //debugger;
    this.mode = FormMode.Edit;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
    localStorage.setItem('rateFileId', p.id.toString());

      //this.resetFileManagerForm();
  }

  showDel(p: any) {
    this.mode = FormMode.Del;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
  }


  public loadRateFiles(carrierCode: string) {
    this.rateFileService.getRateFiles(carrierCode).subscribe(
      r => {
        if (r) {
          this.rateFiles = r;
          this.showratefiletabledata = this.rateFiles;
          this.RateFiledataSource = new MatTableDataSource(this.showratefiletabledata);
          //  this.RateFiledataSource.paginator = this.paginator;
          this.RateFiledataSource.paginator = this.paginator;

        }
        console.log("Inside loadRateFiles", this.RateFiledataSource.paginator)

      },
      e => {
        this.openSnackBar('Failed to get rate files', 'error');
      }
    );
  }

  public loadRateFileServiceCodes(p: CarrierRateFile, onSuccess: (hasdata: boolean) => void) {
    this.rateFileService.get<string[]>(p.id, "getservicecodes").subscribe(
      r => {
        p.serviceCodes = r;
        if (p.serviceCodes != null && p.serviceCodes.length > 0) {
          if (onSuccess != null) {
            onSuccess(true);
          }
        } else {
          if (onSuccess != null) {
            onSuccess(false);
          }
        }
      },
      e => {
        this.openSnackBar('Failed to get service codes', 'error');

      }
    );
  }

  public loadCarrierRates(p: CarrierRateFile, carrierCode: string, onSuccess: (hasdata: boolean) => void) {
    p.carrierCode = carrierCode;
    this.rateFileService.get<CarrierRateSheet>(p.id, "getcarrierrates", carrierCode).subscribe(
      r => {
        //this.carrierRateTTable.reset();
        p.carrierRateSheet = r;
        p.carrierRateSheet.cols.unshift('Weight/Zone');
        p.ColList = new Array();
        if (p.carrierRateSheet.cols != null && p.carrierRateSheet.cols.length > 0) {
          p.carrierRateSheet.cols.forEach((e: string) => {
            p.ColList.push({ field: e, header: e });
          });
          if (onSuccess != null) {
            onSuccess(true);
          }
          // this.CarrierRateFilesColsWithStatic = this.CarrierRateFilesCols.concat(['Weight/Zone']);
        }
        else {
          if (onSuccess != null) {
            onSuccess(false);
          }
        }
      },
      e => {
        // this.alert.send(AlertMessage.getOnHttpError("GetCarrierRatesFail", "Failed to get rates", e));
        this.openSnackBar('Failed to get rates', 'error');

      }
    );
  }

  public upload(e: any) {

    // e.CarrierId = this.Carrier.id;
    // e.formData.append('CarrierId', this.Carrier.id);
    // e.formData.append('FileLabel', this.FileLabel);
  }

  public onBeforeSendFile(e: any) {
  }
  dealWithFiles(e: any) {
    // // myfile = e.originalEvent.files;
    // const formData: FormData = new FormData();
    // // formData.append('json', JSON.stringify(catalogacion));

    // for (let file of e.files) {
    //   formData.append('CarrierId', this.Carrier.id);
    // }

    // console.log(formData);
    // // e.formData.append('CarrierId', this.Carrier.id);
    // // e.formData.append('FileLabel', this.FileLabel);
  }

  public onBeforeUpload(e: any) {
    this.snackservice.loader();
    const formData: FormData = new FormData();
    e.formData.append('CarrierCode', this.model.carrierCode);
    e.formData.append('FileLabel', this.model.label);
  }

  public onUploadComplete(e: any) {
    console.log("Inside Upload", this.RateFiledataSource.paginator);
    //debugger;
    setTimeout(() => {
      this.snackservice.CloseProgressSpinner(true);
    }, 300);
    if (e.originalEvent.body == null) {
      // this.alert.send(new AlertMessage("CarrierRateFileUploadCompleted", "Rate file uploaded sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Rate file uploaded sucessfully', 'success');
      this.resetFileManagerForm();
    //this.loadRateFiles(this.selectedCarrierCode);
    } else {
      if (e.originalEvent.body == "LabelExist") {
        this.openSnackBar('Rate file already exists with this label', 'error');
      } else if (e.originalEvent.body.active == false) {
        // this.alert.send(new AlertMessage("CarrierRateFileUploadError", "Rate file upload failed", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Toast }));
        this.openSnackBar('Upload rate file format is not proper', 'error');
      }
    }
  }

  public onUploadError(e: any) {
    setTimeout(() => {
      this.snackservice.CloseProgressSpinner(true);
    }, 300);
    if (e.error == undefined || e.error == null) {
      // this.alert.send(new AlertMessage("CarrierRateFileUploadError", "Rate file upload failed", AlertSeverity.Error));
      this.openSnackBar('Rate file upload failed', 'error');
    }
    else {
      // this.alert.send(AlertMessage.getOnHttpError("CarrierRateFileUploadError", "Rate file upload failed", e.error));
      this.openSnackBar('Rate file upload failed', 'error');
    }
    this.resetFileManagerForm();
  }


  public resetFileManagerForm() {
    //this.mode = FormMode.None;
    // this.formRateFileDataTable.reset();

    this.model.label = null;
    this.model.carrierCode = "";
  }

  public viewRateFile(p: CarrierRateFile) {

    this.selectedRateFile = p;
    // this.CarrierRateArray.push(p.carrierRateSheet.cells)
    // this.CarrierRateDataSource = new MatTableDataSource(this.CarrierRateArray);
    this.selectedRateFile.selected = true;
    // this.selectedRateFile.status = 1;
    if (this.selectedRateFile.status != this.FileParseStatus.Completed) {
      // this.alert.send(new AlertMessage("CarrierRateFileNotReady", "File status isn't 'Completed'", AlertSeverity.Warning));
      this.openSnackBar('File status is not Completed', 'notification');

    } else {
       let dialogRef = this.dialog.open(this.showcarrierratesPopup);
      this.loadRateFileServiceCodes(p, (hs1) => {
        if (hs1) {
          // let dialogRef = this.dialog.open(this.showcarrierratesPopup);
          this.loadCarrierRates(p, p.serviceCodes[0], (hs2) => {
            if (hs2) {
              //this.CarrierRateArray.push(p.carrierRateSheet.cols)
              this.CarrierRateColArray = p.carrierRateSheet.cols;
              // this.CarrierRateDataSource = new MatTableDataSource(this.CarrierRateArray);

              //this.CarrierRateCellArray
              for (let i = 0; i < p.carrierRateSheet.cells.length; i++) {
                for (let j = 0; j < p.carrierRateSheet.rows.length; j++) {
                  for (let k = 0; k < p.carrierRateSheet.cells[i].length; k++) {
                    if (k == 0) {
                      p.carrierRateSheet.cells[j][k].rowValue = p.carrierRateSheet.rows[j];
                      // p.carrierRateSheet.cells[j][k].rate = p.carrierRateSheet.rows[j];
                    } else {
                      p.carrierRateSheet.cells[j][k].rowValue = "";
                      // p.carrierRateSheet.cells[j][k].rate = p.carrierRateSheet.rows[j];
                    }
                    //break;
                  }
                  //break;
                  // this.CarrierRateCellArray = (p.carrierRateSheet.cells);
                }
                break;
              }
              for (var i = 0; i < p.carrierRateSheet.cells.length; i++) {
                this.CarrierRateArray[i] = [];
              }
              for (let i = 0; i < p.carrierRateSheet.cells.length; i++) {
                //for (let k = 0; k < p.carrierRateSheet.cells[i].length; k++) {
                for (let j = 0; j < p.carrierRateSheet.cols.length; j++) {
                  let cellArray = p.carrierRateSheet.cells[i];
                  if (j == 0) {
                    // this.CarrierRateArray[i][j].push(p.carrierRateSheet.cells[i][j].rowValue);
                    this.CarrierRateArray[i].push(cellArray[j].rowValue);
                    // this.CarrierRateArray[i][j] = cellArray[j];
                  }
                  else {
                    //let cellArray = p.carrierRateSheet.cells[i];
                    //for ( let k =0; k < cellArray.length; k++) {
                    var n = j - 1;
                    this.CarrierRateArray[i].push(cellArray[n].rate);
                    //}
                  }
                }
                // break;
                //}
              }
              // for ( let i = 0; i < p.carrierRateSheet.cells.length; i++ ) {
              //   for (let k = 0; k < p.carrierRateSheet.cells[i].length; k++) {
              //     for (let j = 0; j < p.carrierRateSheet.cols.length ; j++) {
              //       if (j == 0) {
              //         this.CarrierRateArray.push(p.carrierRateSheet[k].carrierRate);
              //       } else {
              //         this.CarrierRateArray.push(p.carrierRateSheet[k].carrierRate);
              //       }
              //     }
              //     break;
              //   }
              // }
              console.log(this.CarrierRateArray)
              this.ShowCarrierRates = true;
              // let dialogRef = this.dialog.open(this.showcarrierratesPopup);
            }
          });
        } else {
          this.alert.send(new AlertMessage("CarrierRateFileNoData", "No data found in the rate file", AlertSeverity.Fatal));
          this.openSnackBar('No data found in the rate file', 'notification');

        }
      });
    }
  }

  public viewFileProcessingError(p: CarrierRateFile) {
    // this.alert.send(new AlertMessage("CarrierRateFileProcessingError", "Uploaded file read error: <hr/> " + p.statusLog, AlertSeverity.Fatal));
    this.openSnackBar('Uploaded file read error: <hr/> ', 'error');

  }

  public viewCarrierRate(p: CarrierRate) {
    if (this.selectedRateFile.carrierRate != null) {
      this.selectedRateFile.carrierRate.selected = false;
    }
    this.selectedRateFile.carrierRate = p;
    this.selectedRateFile.carrierRate.selected = true;
  }

  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }

  close(){
    this.dialog.closeAll();
    this.RateFiledataSource = new MatTableDataSource(this.tabledata);
    this.RateFiledataSource.paginator = this.paginator;
   }

}
